import request from '../util/request.js'

// 获取所有配置
export function ConfigListAll(code) {
	return request({
		method: 'get',
		url: `/api/config/listAll`
	})
}
